import dynamic from 'next/dynamic';
import { I_CallToAction } from '@containers/Home/types';
import { memo, useCallback, useMemo, useState } from 'react';
import { CallToActionItemWrapper } from './styled';

const Fancybox = dynamic(() => import('./Fancybox'), { ssr: false });

interface Props {
  item: I_CallToAction;
}

const CallToActionItem = memo(({ item }: Props) => {
  const [isShowFancybox, setIsShowFancybox] = useState(false);

  const icon = item.typeIcon === 'image' ? item.icon : item.icon?.split('/')[1];

  const targetHref = useMemo(() => {
    switch (item.typeValue) {
      case 'whatsapp':
      case 'viber':
      case 'link':
        return item.value;
      case 'mailto':
        return `mailto:${item.value}`;
      case 'tel':
        return `tel:${item.value}`;
      default:
        return item.value;
    }
  }, [item]);

  const onCloseFancybox = useCallback(() => {
    setIsShowFancybox(false);
  }, []);

  const onClickLink = useCallback(() => {
    if (item.typeValue === 'link') {
      console.log('item?.action :', item?.action);
      if (item?.action !== 'iframe')
        window.open(
          targetHref,
          item?.action === 'same-tab' ? '_self' : '_blank',
          item?.action === 'new-window'
            ? 'location=yes,height=570,width=520,scrollbars=yes,status=yes'
            : undefined,
        );
      else setIsShowFancybox(true);
    }
  }, [item, targetHref]);

  return (
    <>
      <CallToActionItemWrapper
        as={item.typeValue === 'link' ? 'div' : 'a'}
        target="_blank"
        href={targetHref}
        className="itemLink"
        scale={item.scale || 1}
        onClick={onClickLink}
      >
        {item.typeIcon === 'image' ? (
          <img className="--symbol" src={icon} alt={item?.title} />
        ) : (
          <i aria-hidden className={`--symbol ${icon}`} />
        )}
        <span>{item.title || ''}</span>
        <i aria-hidden className="--arrow fal fa-angle-right" />
      </CallToActionItemWrapper>
      {isShowFancybox && (
        <Fancybox src={targetHref} onClose={onCloseFancybox} />
      )}
    </>
  );
});

export default CallToActionItem;
